"use strict";
var Observable_1 = require('../../Observable');
var fromEventPattern_1 = require('../../observable/fromEventPattern');
Observable_1.Observable.fromEventPattern = fromEventPattern_1.fromEventPattern;
//# sourceMappingURL=fromEventPattern.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/add/observable/fromEventPattern.js
// module id = ./node_modules/rxjs/add/observable/fromEventPattern.js
// module chunks = vendor